/**
 * electric auth token list
 *
 * List API tokens in a workspace.
 */

import { Command } from 'commander'
import { createClient } from '../../../client.js'
import { resolveWorkspace } from '../../../lib/workspace-resolver.js'
import { handleError } from '../../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printTable } from '../../../output.js'

export const tokenListCommand = new Command(`list`)
  .description(`List API tokens in a workspace`)
  .option(`--workspace <id>`, `Workspace ID`)
  .action(async (opts) => {
    const json = tokenListCommand.parent?.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const workspaceId = await resolveWorkspace(client, opts.workspace)
      const result = await client.tokens.list({ workspaceId })

      if (isQuiet()) {
        for (const t of result.tokens) {
          printQuiet(t.id)
        }
        return
      }

      if (json) {
        printJson(result)
      } else {
        printTable(
          [`ID`, `Name`, `Prefix`, `Scopes`, `Created`],
          result.tokens.map((t) => [
            t.id,
            t.name,
            t.tokenPrefix,
            t.scopes.join(`, `),
            t.createdAt.slice(0, 10),
          ])
        )
      }
    } catch (error) {
      handleError(error, json)
    }
  })
